import apiFetch from '../apiFetch'

export default function (token, destinationCraneId) {
  return apiFetch({ endPoint: `DestinationCrane/${destinationCraneId}`, method: 'DELETE', body: null, token: token })
}
